import { Box, Grid, Stack, Tab, Tabs, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useLocation, useNavigate } from 'react-router';
import TooltipCustomize from 'src/components/TooltipCustomize';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import useQueryUrl from 'src/hooks/useQuery';
import { useState } from 'react';
import { useAppSelector } from 'src/app/hooks';

const HeaderWrapper = styled(Box)(
  ({ theme }) => `
    color: ${theme.header.textColor};
    padding: ${theme.spacing(1, 4, 0, 4)};
    right: 0;
    z-index: 5;
    box-shadow: ${theme.header.boxShadow};
    justify-content: space-between;
    width: 100%;
    background: ${theme.header.background};
    @media (min-width: ${theme.breakpoints.values.lg}px) {
        left: ${theme.sidebar.width};
        width: auto;
    }
`
);

function HeaderCustomReport() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const query = useQueryUrl();
  const tabQuery = query.get('tab');
  const [tab, setTab] = useState<string>(tabQuery ?? 'slide_report');
  const { id: projectId, timezone } = useAppSelector(
    (state) => state.users.project
  );

  const handleChange = (_: React.SyntheticEvent, newValue: string) => {
    setTab(newValue);
    navigate(`${pathname}?tab=${newValue}`);
  };

  return (
    <HeaderWrapper display="flex" alignItems="center">
      <Grid container>
        <Grid item xs={12}>
          <Stack direction="row" alignItems="center">
            <Typography
              variant="h1"
              sx={{
                mr: 1
              }}
            >
              Custom Report
            </Typography>
            <TooltipCustomize
              title={'Build Custom Report'}
              placement="top-start"
            >
              <InfoOutlinedIcon
                fontSize="small"
                sx={{ transform: 'translateY(-4px)' }}
              />
            </TooltipCustomize>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs
              value={tab}
              onChange={handleChange}
              aria-label="report tabs"
              // scrollButtons={true}
              variant="scrollable"
              sx={{
                maxWidth: { xs: '80vw', md: '100%' },
                width: '100%',
                overflow: 'scroll',
                '&::-webkit-scrollbar': {
                  display: 'none'
                }
              }}
            >
              <Tab label="Slide Report" value="slide_report" />
              <Tab label="Snap Report" value="snap_report" />
              <Tab label="Newsletter" value="news_letter" />
              <Tab label="Scheduled Report" value="scheduled_report" />
              <Tab label="Curated Email Report" value="curated_stream_report" />
              {(projectId === 'ef7a0043-01c3-4556-b92a-678962c54c3d' ||
                projectId === 'c960b616-7847-472f-9e16-e47941536fd7') && (
                <Tab
                  label="Monitoring Daily Report"
                  value="monitoring_daily_report"
                />
              )}
              {timezone === 8 && (
                <Tab label="Summary Report" value="summary_report" />
              )}
            </Tabs>
          </Box>
        </Grid>
      </Grid>
    </HeaderWrapper>
  );
}

export default HeaderCustomReport;
